module.exports = __webpack_public_path__ + "static/media/video01.96783439.jpg";